
import React from 'react';
import SectionLayout from '@/components/SectionLayout';
import OpeningHook from './OpeningHook';
import IntroductionCard from './IntroductionCard';
import ProblemGrid from './ProblemGrid';
import PainPointEmphasis from './PainPointEmphasis';
import SolutionVision from './SolutionVision';
import CourseIntroduction from './CourseIntroduction';

const ProblemSolutionSection = () => {
  return (
    <SectionLayout paddingY="py-16 sm:py-20 md:py-24" backgroundColor="bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <OpeningHook />
        <IntroductionCard />
        <ProblemGrid />
        <PainPointEmphasis />
        <SolutionVision />
        <CourseIntroduction />
      </div>
    </SectionLayout>
  );
};

export default ProblemSolutionSection;
